import React, {MouseEvent} from "react";
import intl from "react-intl-universal";
import classNames from "classnames";

import {TextLink} from '../../../../../components/TextLink';


export interface LoginButtonProps {
    handleLogInClick: (event: MouseEvent) => void;
    className?: string;
}

export const LoginButton = ({className, handleLogInClick}: LoginButtonProps) => {
    return (
        <div className={classNames({
            'Auth-policy-info body-medium': true,
            [className!]: !!className,
        })}>
            <span>{intl.get('sign_up.already').d('Already have an account?')}</span>
            <TextLink
                className={'Auth__inline-btn'}
                onClick={handleLogInClick}
                text={intl.get('sign_up.log_in').d('Log In')}
            />
        </div>
    )
}
